/**
 * Created by lycheng on 2017/11/23.
 * 登陆成功之后拼接html
 */
import { config } from 'config'

function getHtml () {
  this.getTypeClass = (info) => {
    let typeClass = 'uncerti'
    switch (info.certificate) {
      case '个人认证': {
        typeClass = 'personal'
        break
      }
      case '学生认证': {
        typeClass = 'student'
        break
      }
      case '创业团队认证': {
        typeClass = 'business-team'
        break
      }
      case '企业认证': {
        typeClass = 'company'
        break
      }
      default: {
        typeClass = 'uncerti'
      }
    }
    return typeClass
  }

  this.renderHtml = function (userinfo) {
    return `<div class="header-control">
    <a class="header-link to-console" href="${config.CONSOLE}app/myapp" target="_self">控制台</a>
  </div>
  <i class="icons icons-splite">|</i>
  <div class="header-userinfo">
    <a class="userinfo-name">
      <span class="name">
        ${userinfo.userName}
      </span>
    </a>
    <div class="userinfo-detail">
      <div class="userinfo-top userinfo-item-box">
        <div class="userinfo-email" title="${userinfo.email ? userinfo.email : ''}"><span class="us-email">${userinfo.email ? userinfo.email : ''}</span></div>
        <div class="certi-area">
          <div class="certi-every certi-${this.getTypeClass(userinfo)}" elink="${userinfo.toCertificate}">
            <div class="icon-cert ${this.getTypeClass(userinfo)}-icon"></div>
            <span>${userinfo.certificate}</span>
          </div>
        </div>
      </div>
      <div class="userinfo-middle userinfo-item-box">
        <div class="userinfo-balance-wrap">
          <div class="userinfo-charge">
            <span>
              <svg class="icons-svg">
                <use xlink:href="#icon-dollor"></use>
              </svg>
              余额
            </span>
            <a class="link to-charge" href="${config.CONSOLE}center/charge" target="_blank">
              立即充值
            </a>
          </div>
          <span class="userinfo-balance">¥${userinfo.balance}</span>
        </div>
        <a class="userinfo-link" href="${config.CONSOLE}app/myapp" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-appmanage"></use>
          </svg>
          我的应用
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}center/order" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-order"></use>
          </svg>
          订单管理
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}user/personaldata" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-user"></use>
          </svg>
          基本资料
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}workorder/myworkorder" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-workorder"></use>
          </svg>
          我的工单
        </a>
      </div>
      <div class="userinfo-bottom userinfo-item-box">
        <a class="userinfo-link to-logout" href="javascript:void(0)">
          <svg class="icons-svg">
            <use xlink:href="#icon-logout"></use>
          </svg>
          退出登录
        </a>
      </div>
    </div>
  </div>`
  }
}

export default getHtml



// WEBPACK FOOTER //
// ./src/js/libs/utils-login-html.js